<template src="./template.html"></template>

<script>
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'SearchResultsPage',
    metaInfo() {
      return {
        title: this.$t('meta.search_results.title', { query: this.query }),
      }
    },
    components: {
      ComponentLoader: () => import('@/components/modules/ComponentLoader'),
    },
    computed: {
      ...mapState('pages', [
        'page',
        'modules',
      ]),
      query() {
        return this.$route.query.q || ''
      },
    },
    watch: {
      query() {
        this.requestData()
      },
    },
    created() {
      this.getUsersListOptions()
    },
    destroyed() {
      this.resetUserIdentifiers()
    },
    mounted() {
      this.requestData()
    },
    methods: {
      ...mapActions('pages', ['getSearchResultsPage']),
      ...mapActions('users', [
        'getUsersListOptions',
        'resetUserIdentifiers',
      ]),
      async requestData() {
        await this.getSearchResultsPage(this.query)
        if (this.modules && this.modules.length === 0) {
          this.$router.replace({ name: 'result-not-found' })
        }
      },
    },
  }
</script>
